import React, { useEffect, useState, useMemo } from 'react';
import { Drawer, Tabs, Input, Spin, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { startLoadDirectorioCorralones, startSearchTalleres } from '../../../context/actions/detalleActions';
import { useDebounce } from '../../../hooks/useDebounce';
import { CardTaller } from './CardTaller';
import { CardCorralon } from './CardCorralon';

const { TabPane } = Tabs;
const { Search } = Input;

export const DatosDrawer = ({ visible, onClose }) => {
  const dispatch = useDispatch();
  const { talleres, corralones, loadingDatosDrawer } = useSelector((state) => state.detalleReducer);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCiudad, setSelectedCiudad] = useState(null);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    if (visible) {
      dispatch(startLoadDirectorioCorralones());
    }
  }, [visible, dispatch]);

  useEffect(() => {
    if (debouncedSearchTerm.length >= 3 || debouncedSearchTerm.length === 0) {
      dispatch(startSearchTalleres(debouncedSearchTerm));
    }
  }, [debouncedSearchTerm, dispatch]);

  const ciudades = useMemo(() => {
    const ciudadesSet = new Set();
    corralones.forEach((corralon) => {
      if (corralon.cdr) {
        ciudadesSet.add(corralon.cdr);
      }
    });
    return Array.from(ciudadesSet).sort();
  }, [corralones]);

  const corralonesFilterd = useMemo(() => {
    if (!selectedCiudad) {
      return corralones;
    }
    return corralones.filter((corralon) => corralon.cdr === selectedCiudad);
  }, [corralones, selectedCiudad]);

  return (
    <Drawer
      title="Talleres y Corralones"
      placement="right"
      onClose={onClose}
      visible={visible}
      width={650}
    >
      <Tabs defaultActiveKey="1">
        <TabPane tab="Talleres" key="1">
          <Search
            placeholder="Buscar taller..."
            onChange={(e) => setSearchTerm(e.target.value)}
            allowClear
            style={{ marginBottom: '16px' }}
            loading={loadingDatosDrawer}
          />
          {loadingDatosDrawer ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <Spin />
            </div>
          ) : (
            talleres.map((item) => (
              <CardTaller key={item.id} item={item} />
            ))
          )}
        </TabPane>
        <TabPane tab="Corralones" key="2">
          <Select
            placeholder="Filtrar por ciudad"
            allowClear
            showSearch
            style={{ width: '100%', marginBottom: '16px' }}
            onChange={(value) => setSelectedCiudad(value)}
            value={selectedCiudad}
            options={ciudades.map((ciudad) => ({
              label: ciudad,
              value: ciudad,
            }))}
          />
          {loadingDatosDrawer && corralones.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <Spin />
            </div>
          ) : (
            corralonesFilterd.map((item) => (
              <CardCorralon key={item.id} item={item} />
            ))
          )}
        </TabPane>
      </Tabs>
    </Drawer>
  );
};